import { PAGINATION_RECORD_PER_PAGE } from "MainApp/features/App/constants";

export const SUGGESTED_USERS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;
export const SUGGESTED_USERS_INIT_COUNT = 5;